/**
 * Immutably set a key on a Map, returning a new Map. Mirrors the
 * legacy `mapSet` util that the chat code relies on for BehaviorSubject
 * updates — same identity semantics as updating an object via spread.
 */
export function mapSet<K, V>(map: Map<K, V>, key: K, value: V): Map<K, V> {
  const next = new Map(map);
  next.set(key, value);
  return next;
}
